import { Navigate } from 'react-router-dom'

import { AppLoadingScreen } from 'src/components'
import { OrganizationsPage } from 'src/features/organizations'
import { useSessionContext } from 'src/hooks'
import { FocusedShell } from 'src/layout'

import {
  resolveWorkspaceLanding,
  workspaceLandingPath
} from './resolveWorkspaceLanding'

/**
 * Chrome + guard for the post-login workspace chooser. Renders the canonical
 * `OrganizationsPage` picker (the same one served at `/workspaces`) inside the
 * focused standalone shell — no sidebar, because at selection time there is no
 * active workspace to frame. `AuthGuard` wraps this route, so `user` resolves
 * once the session loads.
 */
export const WorkspaceSelectRoute = () => {
  const { user, isLoading } = useSessionContext()

  if (isLoading || !user) {
    return <AppLoadingScreen />
  }

  // Deliberately ignore the remembered workspace: this route always *offers the
  // choice* (the remembered fast-path lives in DefaultLandingRedirect). Reusing
  // the shared resolver keeps the 0-workspace (→ create) and single-workspace
  // (→ enter) cases from dead-ending on an empty chooser.
  const REMEMBERED_IGNORED = undefined
  const landing = resolveWorkspaceLanding(
    user.organizations ?? [],
    REMEMBERED_IGNORED
  )

  if (landing.kind !== 'select') {
    return <Navigate to={workspaceLandingPath(landing)} replace />
  }

  return (
    <FocusedShell>
      <OrganizationsPage />
    </FocusedShell>
  )
}
